import React from 'react';
import GeneralAutocompleteFilter, { ConcreteAutocompleteFilterProps } from "./GeneralAutocompleteFilter";

const VoivodeshipsFilter: React.FC<ConcreteAutocompleteFilterProps> = props => {
    return (
        <GeneralAutocompleteFilter
            multiple
            name={ props.name || 'voivodeships' }
            label={ props.label || 'Województwa' }
            onFilterChange={ props.onFilterChange }
            options={ props.options }
            values={ props.values }
        />
    );
}
export default VoivodeshipsFilter;